import { Component } from 'react'
import { action, observable, makeObservable } from 'mobx'
import { listenElementDimensionsChange, sendMessageToEmbeded } from 'utils/embedWidget.utils'
import { POST_MESSAGE_ACTIONS } from './common/variables'

class IframeListener extends Component {
  @observable embedOrigin = null
  @observable index = 0

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  componentDidMount() {
    this.listenEmbedMessage()
  }

  msgHandler = (e) => {
    if (e.origin !== 'https://js.stripe.com') {
      this.handleMessageReceived(e.data)
    }
  }

  listenEmbedMessage = () => {
    if (window.addEventListener) {
      window.addEventListener('message', this.msgHandler, false)
    } else {
      window.attachEvent('onmessage', this.msgHandler)
    }
  }

  @action handleMessageReceived = (props) => {
    const { iframeSrc, index, action } = props
    const shouldProcessMsg =
      (window.location.href === iframeSrc && (index === this.index || !this.index)) ||
      action === POST_MESSAGE_ACTIONS.redirection
    if (shouldProcessMsg) this.processMessage(props)
  }

  processMessage = (props) => {
    const { action, index, url } = props
    if (action === POST_MESSAGE_ACTIONS.iframeInjected) {
      this.embedOrigin = url
      this.index = index
      const wrapper = document.getElementById('wrapper')
      if (wrapper) listenElementDimensionsChange(wrapper.children[0], this.resizeIframeMessage)
      this.notifyLoadComplete()
    } else if (action === POST_MESSAGE_ACTIONS.redirection) {
      sendMessageToEmbeded({
        msg: {
          action: POST_MESSAGE_ACTIONS.redirection,
          iframeSrc: window.location.href,
          url,
        },
        origin: '*',
      })
    }
  }

  resizeIframeMessage = (attrs) => {
    sendMessageToEmbeded({
      msg: {
        action: 'resize',
        iframeSrc: window.location.href,
        index: this.index,
        ...attrs,
      },
      origin: '*',
    })
  }

  notifyLoadComplete = () => {
    sendMessageToEmbeded({
      msg: {
        action: POST_MESSAGE_ACTIONS.iframeMounted,
        iframeSrc: window.location.href,
      },
      origin: '*',
    })
  }

  render() {
    return null
  }
}

export default IframeListener
